import React from "react";
import { config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClone,
  faLayerGroup,
  faLock,
  faObjectGroup,
  faObjectUngroup,
  faRotateLeft,
  faTrashCan,
} from "@fortawesome/pro-regular-svg-icons";
import type { CSSProperties } from "react";

config.autoAddCss = false;

type IconProps = {
  size?: number;
  "aria-hidden"?: boolean;
  style?: CSSProperties;
  className?: string;
};

function createIcon(icon: IconDefinition, defaultStyle?: CSSProperties) {
  return function Icon({ size = 16, style, className, ...rest }: IconProps) {
    return (
      <FontAwesomeIcon
        icon={icon}
        aria-hidden={rest["aria-hidden"]}
        className={className}
        style={{
          fontSize: size,
          width: size,
          height: size,
          ...defaultStyle,
          ...style,
        }}
      />
    );
  };
}

export const ChevronDown = createIcon(faChevronDown);
export const ChevronLeft = createIcon(faChevronLeft);
export const ChevronRight = createIcon(faChevronRight);
export const ChevronUp = createIcon(faChevronUp);
export const Copy = createIcon(faClone);
export const Layers = createIcon(faLayerGroup);
export const ObjectGroup = createIcon(faObjectGroup);
export const ObjectUngroup = createIcon(faObjectUngroup);
export const Lock = createIcon(faLock);
export const Trash2 = createIcon(faTrashCan);
export const RotateCcw = createIcon(faRotateLeft);
